import { initializeApp } from 'firebase/app';
import { getFirestore, Timestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyBweqDkVgDUg7dhf8eqexyxZcf8AKG-S98',
  authDomain: 'tip-dev-1b385.firebaseapp.com',
  projectId: 'tip-dev-1b385',
  storageBucket: 'tip-dev-1b385.appspot.com',
  messagingSenderId: '134048178659',
  appId: '1:134048178659:web:add349a6fe7f65a33640d6',
};

// Init firebase
const app = initializeApp(firebaseConfig);

// Init firestore
const db = getFirestore(app);

// Init firebase Auth
const auth = getAuth(app);

// timestamp
const timestamp = Timestamp;

export { db, auth, timestamp };
